// eslint-disable-next-line max-len
const cbFilter = (list: any[], search: string) => list.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()))

export default cbFilter
